import { Component, OnInit } from '@angular/core';
import { CommonUtilities } from 'src/assets/js/common-utilities';

@Component({
  selector: 'app-c-existingvendor',
  templateUrl: './c-existingvendor.component.html',
  styleUrls: ['./c-existingvendor.component.css']
})
export class CExistingvendorComponent implements OnInit {
  VendorList:any[]
  selectedtab: number = 0;
  displayBasic: boolean;
  constructor(private utility:CommonUtilities) { }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    this.VendorList = [
      {sno:'1',vendorname:'AKR',ratesdetail:'Not Mentioned',customerstrength:'CFT Flexible & Prompt Delivery',vendorpoint:'Not confirmed anything'},
      {sno:'2',vendorname:'ABT',ratesdetail:'Not Mentioned',customerstrength:'On time pick up ',vendorpoint:'Delay Service'}
    ]
  }
  showBasicDialog(){
    this.displayBasic = true;
  }
}
